import { useEffect, useState } from 'react';
import type { ConsultancyStage } from './types';

export const PIPELINE_NAVIGATION_STATE = 'pipeline:navigation-state';
export const PIPELINE_NAVIGATION_REQUEST = 'pipeline:request-navigation';
export const PIPELINE_SELECT_STAGE = 'pipeline:select-stage';

export interface PipelineNavigationState {
  activeStage: ConsultancyStage;
  counts: Partial<Record<ConsultancyStage, number>>;
}

export function usePipelineNavigation(): PipelineNavigationState | null {
  const [state, setState] = useState<PipelineNavigationState | null>(null);
  useEffect(() => {
    const update = (event: Event) => setState((event as CustomEvent<PipelineNavigationState | null>).detail ?? null);
    window.addEventListener(PIPELINE_NAVIGATION_STATE, update);
    window.dispatchEvent(new CustomEvent(PIPELINE_NAVIGATION_REQUEST));
    return () => window.removeEventListener(PIPELINE_NAVIGATION_STATE, update);
  }, []);
  return state;
}
